import { render, staticRenderFns } from "./CancelarAtendimentoModal.vue?vue&type=template&id=5b52c3d9&scoped=true"
import script from "./CancelarAtendimentoModal.vue?vue&type=script&lang=js"
export * from "./CancelarAtendimentoModal.vue?vue&type=script&lang=js"
import style0 from "./CancelarAtendimentoModal.vue?vue&type=style&index=0&id=5b52c3d9&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b52c3d9",
  null
  
)

export default component.exports